import { render, staticRenderFns } from "./AuditingTable.vue?vue&type=template&id=3bcb9dfe"
import script from "./AuditingTable.vue?vue&type=script&lang=ts"
export * from "./AuditingTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports